
$(function () {
  const $window = $(window);
  const $body = $('body');
  let ws = $(this).scrollTop(); // スクロール量を取得

  // ロード時の処理
  $window.on('load', function () {
    ws = $(this).scrollTop(); // スクロール量を取得
    scrolling(ws, $body);
  });

  // スクロール時の処理 - $.throttleはプラグインを利用してます
  $window.on('scroll', $.throttle(1000, function () {
    if (!$body.hasClass('is-menuOpen')) { // メニューを開くときは例外
      ws = $(this).scrollTop(); // スクロール量を取得
      scrolling(ws, $body);
    }
  }));

  // スマホのメニューを開く
  const $buttonOpen = $('.openBtn,.cover'); // ボタン(トリガー)の取得
  const $menu = $('.menu_wrapper'); // メニューの取得
  $buttonOpen.on('click', function () {
    if ($body.hasClass('is-menuClose')) {
      // メニューを開くとき
      const st = $window.scrollTop();
      $body.css({
        top: st * -1
      });
      $menu.fadeIn(300);
      $body.removeClass('is-menuClose').addClass('is-menuOpen');
    } else {
      // メニューを閉じるとき
      const st = parseInt($body.css('top')) * -1;
      $body.removeClass('is-menuOpen').addClass('is-menuClose');
      $window.scrollTop(st);
      $menu.fadeOut(300);
    }
  });
});

// bodyに.scrollingを付与する関数
function scrolling (ws, $body) {
  if (ws > 50) {
    $body.addClass('scrolling');
  } else {
    $body.removeClass('scrolling');
  }
}
